import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "knob", "monthlyLabel", "yearlyLabel", "saveBadge", "starterPrice", "starterBilled", "proPrice", "proBilled"]

  static values = {
    billedYearlyLabel: { type: String, default: "Billed annually" }
  }

  connect() {
    this.isYearly = true
  }

  toggle() {
    this.isYearly = !this.isYearly
    this.updateUI()
  }

  updateUI() {
    if (this.isYearly) {
      this.knobTarget.classList.remove("left-1")
      this.knobTarget.classList.add("left-8")
      this.monthlyLabelTarget.classList.add("text-foreground/50")
      this.monthlyLabelTarget.classList.remove("text-foreground")
      this.yearlyLabelTarget.classList.remove("text-foreground/50")
      this.yearlyLabelTarget.classList.add("text-foreground")
      this.saveBadgeTarget.classList.remove("hidden")

      if (this.hasStarterPriceTarget) {
        this.starterPriceTarget.textContent = "83"
      }
      if (this.hasStarterBilledTarget) {
        this.starterBilledTarget.textContent = this.billedYearlyLabelValue
        this.starterBilledTarget.classList.remove("hidden")
      }
      if (this.hasProPriceTarget) {
        this.proPriceTarget.textContent = "167"
      }
      if (this.hasProBilledTarget) {
        this.proBilledTarget.textContent = this.billedYearlyLabelValue
        this.proBilledTarget.classList.remove("hidden")
      }
    } else {
      this.knobTarget.classList.add("left-1")
      this.knobTarget.classList.remove("left-8")
      this.monthlyLabelTarget.classList.remove("text-foreground/50")
      this.monthlyLabelTarget.classList.add("text-foreground")
      this.yearlyLabelTarget.classList.add("text-foreground/50")
      this.yearlyLabelTarget.classList.remove("text-foreground")
      this.saveBadgeTarget.classList.add("hidden")

      if (this.hasStarterPriceTarget) {
        this.starterPriceTarget.textContent = "100"
      }
      if (this.hasStarterBilledTarget) {
        this.starterBilledTarget.classList.add("hidden")
      }
      if (this.hasProPriceTarget) {
        this.proPriceTarget.textContent = "200"
      }
      if (this.hasProBilledTarget) {
        this.proBilledTarget.classList.add("hidden")
      }
    }
  }
}
